<template>
  <div class="cancellation-request-modal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Solicitação de cancelamento de {{ cancellation_request.lawyer.name }}
        </p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div class="row mt-2">
          <div class="col-12">
            <b-notification
              has-icon
              role="alert"
              type="is-warning"
              :closable="false"
            >
              <p>Motivo:</p>
              <p>{{ cancellation_request.reason }}</p>
            </b-notification>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <b-notification
              has-icon
              icon="comment"
              role="alert"
              type="is-dark"
              :closable="false"
            >
              <p>Observação:</p>
              <p>{{ cancellation_request.observation }}</p>
            </b-notification>
          </div>
        </div>

        <div
          v-if="
            selectedAction == 'reversed' &&
            cancellation_request.type.value == 0 &&
            cancellation_request.over_limit_date
          "
          class="row mt-2"
        >
          <div class="col-12">
            <b-notification
              has-icon
              role="alert"
              type="is-info"
              :closable="false"
            >
              <p>
                Ao confirmar a reversão, um e-mail será enviado ao usuário para
                que ele aprove o processamento do pagamento.
              </p>
            </b-notification>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <div class="card-select-title mb-2">Ação a ser tomada:</div>

            <b-field>
              <b-select v-model="selectedAction" placeholder="Selecione...">
                <b-select-option :value="null">Selecionar</b-select-option>

                <b-select-option
                  v-for="(action, idx) in actions"
                  :value="action.value"
                  :key="idx"
                  >{{ action.label }}</b-select-option
                >
              </b-select>
            </b-field>
          </div>
        </div>

        <div class="row mt-2" v-if="selectedAction === 'lost'">
          <div class="col-12">
            <div class="card-select-title mb-2">
              Estornar último valor pago?
            </div>

            <b-field>
              <b-select v-model="shouldRefund" placeholder="Selecione...">
                <b-select-option :value="null">Selecionar</b-select-option>

                <b-select-option
                  v-for="(action, idx) in shouldRefoundOptions"
                  :value="action.value"
                  :key="idx"
                  >{{ action.label }}</b-select-option
                >
              </b-select>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          @click="save()"
          :loading="isLoading"
          :disabled="isDisabled || isLoading"
          type="is-primary"
          expanded
        >
          Salvar
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import CancellationRequestService from "@/services/cancellation-request.service";

export default {
  components: {},
  props: {
    cancellation_request: {
      type: Object,
    },
  },
  data: () => ({
    isLoading: false,
    selectedAction: null,
    shouldRefund: null,
    actions: [
      { value: "reversed", label: "Reverter" },
      { value: "lost", label: "Confirmar cancelamento" },
    ],
    shouldRefoundOptions: [
      { value: true, label: "Sim" },
      { value: false, label: "Não" },
    ],
  }),
  computed: {
    isDisabled() {
      if (!this.selectedAction || this.selectedAction === "lost")
        return this.shouldRefund === null;

      return this.selectedAction !== "reversed";
    },
  },
  methods: {
    save() {
      this.isLoading = true;

      const data = {
        action: this.selectedAction,
      };

      if (data["action"] === "lost") {
        data["should_refund"] = this.shouldRefund;
      }

      CancellationRequestService.update(
        this.cancellation_request.lawyer.id,
        data,
      )
        .then(({ data }) => {
          const { message } = data;
          this.$buefy.snackbar.open(message);
          this.$emit("close", true);
        })
        .catch(() =>
          this.$buefy.snackbar.open(
            "Erro ao atualizar solicitação, tente novamente",
          ),
        )
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
